import { format } from 'date-fns';
import { observer } from 'mobx-react-lite';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Tab, Image, Icon, TabProps, Grid, Header } from 'semantic-ui-react';
import { UserActivity2 } from '../../app/models/userActivity2';
import { UserActivity } from '../../app/models/userActivity';
import { useStore } from '../../app/stores/store';

function ProfileActivities() {
    const usStore = useStore();

    const paneArray = [
        { menuItem: 'Future Events', pane: { key: 'future' } },
        { menuItem: 'Past Events', pane: { key: 'past' } },
        { menuItem: 'Hosting', pane: { key: 'hosting' } },
    ]

    useEffect(() => {
        usStore.profileStore.loadUserActivities(usStore.profileStore.profile!.userName);
    }, [usStore.profileStore.loadUserActivities, usStore.profileStore.profile]);

    const handleTabChange = (event: SyntheticEvent, data: TabProps) => {
        usStore.profileStore.loadUserActivities(usStore.profileStore.profile!.userName, paneArray[data.activeIndex as number].pane.key);
    };

    // function handleLoadUserActivities(activeIndexNumber: any) { //'o
    //     usStore.profileStore.loadUserActivities(usStore.profileStore.profile!.userName, activeIndexNumber=== 0 ? 'future' : activeIndexNumber === 1 ? 'past' : 'hodting' );
    //     console.log(usStore.profileStore.userActivity2Array);
    // }

    // return (
    //     // <Tab.Pane>Events Content</Tab.Pane>
    //     <Tab.Pane loading={usStore.profileStore.bLoadingActivities}>
    //         <>
    //         <Tab 
    //             menu={{
    //                 fluid: true, 
    //                 //vertical: true,
    //             }}
    //             //menuPosition='left'
    //             panes={paneArray}
    //             onTabChange={(event, data) => handleLoadUserActivities(data.activeIndex) } 
    //         />

    //         {usStore.profileStore.userActivity2Array && 
    //             usStore.profileStore.userActivity2Array.map((x) => {
    //                 <Card as={Link} to={`/profiles/${usStore.profileStore.profile!.userName}`} >
    //                     <Image src={usStore.profileStore.profile!.photoUrl || `/assets/user.png`} />
    //                     <Card.Content>
    //                         <Card.Header>{usStore.profileStore.profile!.displayName}</Card.Header>
    //                         {usStore.profileStore.profile!.bio && (
    //                             // <Card.Description>{usStore.profileStore.profile.bio.length < 40 ? usStore.profileStore.profile.bio : usStore.profileStore.profile.bio.substring(0, 37) + '...' }</Card.Description>
    //                             <Card.Description>{usStore.profileStore.profile!.bio}</Card.Description>
    //                         )}
    //                     </Card.Content>
    //                     <Card.Content extra>
    //                         <Icon name='user'/>
    //                         {usStore.profileStore.profile!.followersCount + 50} followers
    //                     </Card.Content>
    //                 </Card>

    //             })
            
    //         }

    //         <Button content="Load user activities" onClick={handleLoadUserActivities} loading={usStore.profileStore.bLoadingActivities} />

    //         </>
    //     </Tab.Pane> 
    // )


    return (
        <Tab.Pane loading={usStore.profileStore.bLoadingActivities}>
            <Grid>
                <Grid.Column width={16}>
                    <Header floated='left' icon='calendar' content={'Activities'} />
                </Grid.Column>
                <Grid.Column width={16}>
                    <Tab
                        panes={paneArray}
                        menu={{ secondary: true, pointing: true }}
                        onTabChange={(e, data) => handleTabChange(e, data)}
                    />
                    <br />
                    <Card.Group itemsPerRow={4}>
                        {usStore.profileStore.userActivity2Array.map((userActivity2: UserActivity2) => (
                            <Card as={Link} to={`/activities/${userActivity2.id}`} key={userActivity2.id} >
                                <Image
                                    src={`/assets/categoryImages/${userActivity2.category}.jpg`}
                                    style={{ minHeight: 100, objectFit: 'cover' }}
                                />
                                <Card.Content>
                                    <Card.Header textAlign='center'>{userActivity2.title}</Card.Header>
                                    <Card.Meta textAlign='center'>
                                        <div>{format(new Date(userActivity2.date), 'do LLL')}</div>
                                        <div>{format(new Date(userActivity2.date), 'h:mm a')}</div>
                                    </Card.Meta>
                                </Card.Content>
                            </Card>
                        ))}
                    </Card.Group>
                </Grid.Column>
            </Grid>
        </Tab.Pane>
    );

}

export default observer(ProfileActivities);